import CutangleItem from '../item/cutangleItem';
import FloatField from './floatField';

/**
 * @class AngleField
 */
export default class AngleField extends FloatField {
    type = 'angle';
    supports = null;
    handle = null;

    /**
     * Do nothing in this case
     */
    updateValue() {}

    /**
     * Do action.
     *
     * @param {CutangleItem} item
     */
    action(item) {
        this.hide();

        if (!item) return;

        item.on('activatePoint', (point, angle, handle) => {
            this.show();
            this.handle = handle;
            this.input.val(Math.round(angle));
        });

        item.on('deactivatePoint', () => this.hide());
    }

    /**
     * Update field with item value.
     */
    updateItem() {
        const value = this.getValue();
        const isStartPoint = this.handle.active.point === 'startPoint';

        this.handle.setAngle(isStartPoint ? 'startAngle' : 'endAngle', value);
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const value = this.getValue();
        const isStartPoint = this.handle.active.point === 'startPoint';

        this.handle.setAngle(isStartPoint ? 'startAngle' : 'endAngle', value + difference);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof CutangleItem;
    }
}
